import { useTheme } from 'styled-components'

import {
  modalAnimationDuration,
  standardModalBodyOpenClassName,
  standardModalPortalClassName,
} from '../../../../../../brunswick/styles/constants'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../../../../modals/NextModal'

import { deriveModalStyles } from './styles'

export const Modal: React.FC<{
  isOpen: boolean
  onModalClose: () => void
  onAfterClose: () => void
  children?: React.ReactNode
}> = ({ isOpen, onModalClose, children, onAfterClose }) => {
  const theme = useTheme()

  return (
    <NextModal
      bodyOpenClassName={standardModalBodyOpenClassName}
      closeTimeoutMS={modalAnimationDuration}
      isOpen={isOpen}
      onRequestClose={onModalClose}
      onAfterOpen={onAfterClose}
      portalClassName={standardModalPortalClassName}
      style={deriveModalStyles(theme)}
    >
      {children}
    </NextModal>
  )
}
